import React from 'react';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsAppChat = () => {
  const phoneNumber = '+254708022458'; // WhatsApp number without + or spaces
  const message = 'Hello! I would like to inquire about your services.'; // Default message

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div
      className="whatsapp-float"
      onClick={handleWhatsAppClick}
      style={{
        position: 'fixed',
        bottom: '100px',
        right: '30px',
        backgroundColor: '#25D366',
        color: 'white',
        borderRadius: '50px',
        padding: '15px 20px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        cursor: 'pointer',
        zIndex: 9998,
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        transition: 'all 0.3s ease',
        fontSize: '16px',
        fontWeight: '600',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.05)';
        e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.4)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.3)';
      }}
    >
      <WhatsAppIcon style={{ fontSize: '28px' }} />
      <span style={{ display: 'inline-block' }}>Start Chat</span>
    </div>
  );
};

export default WhatsAppChat;
